import { observer } from 'mobx-react';
import React from 'react';
import useStores from '../stores/UseStores';
import HiddenCaptcha, { HiddenCaptchaRef } from './HiddenCaptcha';
import NoticeWithButton from './NoticeWithButton';

interface SmsAuthNoticeProps {
  message: string | React.ReactNode;
}

const SmsAuthNotice = (props: SmsAuthNoticeProps): React.JSX.Element => {
  const { message } = props;
  const {
    translateStore: { translate },
    smsLoginStore: { initiateLogin },
    uiStore: { hideNotices },
    languageStore: { currentLanguage },
  } = useStores();
  const captchaRef = React.useRef<HiddenCaptchaRef>(null);

  const handleOnClick = async (): Promise<void> => {
    const token = await captchaRef?.current?.getCaptchaAsync();
    hideNotices();
    initiateLogin(token);
  };

  return (
    <>
      <HiddenCaptcha ref={captchaRef} currentLanguage={currentLanguage} />
      <NoticeWithButton
        text={<p role="alert">{message}</p>}
        buttonProps={{ text: translate('notice.tryAgain'), iconRight: '#sync', onClick: handleOnClick }}
        noticeProps={{ align: 'center', type: 'error' }}
      />
    </>
  );
};

export default observer(SmsAuthNotice);
